/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'clear': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M694.857 146.286V73.143C694.857 32.75 662.107 0 621.714 0H402.286c-40.393 0-73.143 32.75-73.143 73.143v73.143H36.57v73.143h109.715v731.428c0 40.393 32.75 73.143 73.143 73.143H804.57c40.394 0 73.143-32.75 73.143-73.143V219.43H987.43v-73.143H694.857zM402.286 73.143h219.428v73.143H402.286V73.143zM804.57 950.857H219.43V219.43H804.57v731.428z"/><path pid="1" d="M329.143 329.143h73.143v512h-73.143v-512zM475.429 329.143h73.142v512H475.43v-512zM621.714 329.143h73.143v512h-73.143v-512z"/>'
  }
})
